<template>
  <div id="active-program-reports" class="box">
    <WtTile ancestor="ancestor" :col="12"></WtTile>
    <div class="card mb-4">
      <div class="card-content no-padding">
        <WtTile class="no-padding reportTile" parent="parent" :col="12">
          <WtTile class="no-padding" child="child" :col="4">
            <WtTitle h5="h5">Active Program Report</WtTitle>
            <WtTitle h6="h6">
              This queues a job to generate a report of all active programs (not
              part of a reseller).
            </WtTitle>
          </WtTile>
          <WtTile class="no-padding" child="child" :col="6">
            <WtTile class="no-padding" parent="parent" :col="12">
              <WtTile class="no-padding" child="child" :col="3">
                <BField :message="processingDownload ? 'Processing' : ''">
                  <WtButton
                    class="download-btn mt-5"
                    color="primary"
                    :loading="processingDownload"
                    @click.native="downloadStepReport"
                  >
                    DOWNLOAD
                  </WtButton>
                </BField>
              </WtTile>
            </WtTile>
          </WtTile>
        </WtTile>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtButton from "@@/WtButton/WtButton.vue";
import BField from "buefy/src/components/field/Field.vue";

export default {
  name: "ActiveProgramsReport",
  components: { BField, WtButton, WtTitle, WtTile },

  data() {
    return {
      processingDownload: false
    };
  },
  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("program", ["activeProgramsReport"]),

    async downloadStepReport() {
      this.processingDownload = true;

      this.activeProgramsReport()
        .then(response => {
          if (response.status === 200) {
            this.snackBar({
              duration: 5000,
              type: "is-success",
              message:
                "This report has been queued up, you'll receive an email with the download link once it has completed."
            });

            this.processingDownload = false;
          } else {
            this.snackBar({
              duration: 10000,
              type: "is-danger",
              message:
                "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
            });

            this.processingDownload = false;
          }
        })
        // eslint-disable-next-line
        .catch(error => {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message:
              "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
          });

          this.processingDownload = false;
        });
    }
  }
};
</script>
